const commonOptions = {
    credentials: 'same-origin',
};

export const getOptions = method => {
    if (!method) {
        return Object.assign({}, commonOptions);
    }

    return Object.assign({}, { method: method.toUpperCase() }, commonOptions);
};
